
import Vue from "vue";

export default Vue.extend({
  name: "Pre_footer",

  data: () => ({

  }),

});
